export default "__VITE_ASSET__BZBPOJTM__"